import { toast, ToastBar, Toast as HotToast } from "react-hot-toast";
import Close from "./icons/Close";
import InfoCircle from "./icons/InfoCircle";

interface ToastProps {
  t: HotToast;
  title?: string;
}

export default function Toast({ t, title }: ToastProps) {
  const isSuccess = t.type === "success";

  const toastTitle = title ?? (isSuccess ? "Success" : "Something went wrong");
  const containerClass = isSuccess ? "bg-lightEmerald" : "bg-lightError";
  const iconClass = isSuccess
    ? "pathStrokeColorSuccess"
    : "pathStrokeColorError";
  const textClass = isSuccess ? "text-darkEmerald" : "text-darkError";

  return (
    <ToastBar toast={t} style={{ padding: "0" }}>
      {({ message }) => (
        <div
          className={`flex items-start gap-2 p-4 rounded-lg w-pageContent ${containerClass}`}
        >
          <div className="h-6 flex items-center justify-center">
            <InfoCircle className={iconClass} height={16} width={16} />
          </div>
          <div className={`flex flex-col gap-1 flex-1 ${textClass}`}>
            <div className="bodyBold">{toastTitle}</div>
            <div className="bodySmall -mx-[10px] -my-[4px] [&>div]:justify-start">
              {message}
            </div>
          </div>
          {t.type !== "loading" && (
            <div className="h-6 flex items-center justify-center">
              <button onClick={() => toast.dismiss(t.id)}>
                <Close
                  className={
                    isSuccess
                      ? "pathStrokeColorSuccess"
                      : "pathStrokeColorError"
                  }
                />
              </button>
            </div>
          )}
        </div>
      )}
    </ToastBar>
  );
}
